import { render, staticRenderFns } from "./PurchaseDeliveryItem.vue?vue&type=template&id=fedf37b2&"
import script from "./PurchaseDeliveryItem.vue?vue&type=script&lang=ts&"
export * from "./PurchaseDeliveryItem.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseDeliveryItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports